import QuestionValueUnitConversion from "./QuestionValueUnitConversion";

export default class QuestionValueSortConversion extends QuestionValueUnitConversion{
    constructor(value, unit, conversion) {
        super(value, unit);
        this._conversionFactor = conversion;
    }

    get value(){
    	return this._value / this._conversionFactor;
	}

	get conversionFactor() {
		return this._conversionFactor;
	}
}